export const homeVideoLightbox = () => {
    const homeVideoLightboxContainer = document.querySelector('.home-video-lightbox-container'),
          placeholderImageContainer = document.querySelector('.home-video-lightbox-container .wp-block-embed__placeholder'),
          homeVideoLightboxFigure = document.querySelector('.home-video-lightbox-container > figure');
    if(!placeholderImageContainer) return;
    placeholderImageContainer.addEventListener('click', (e) => {
        setTimeout(()=>{
            homeVideoLightboxContainer.classList.add('expanded');
        }, 100);
    });

    homeVideoLightboxContainer.addEventListener('click', () => {
        if(homeVideoLightboxContainer.classList.contains('expanded')){
            homeVideoLightboxContainer.classList.remove('expanded');
            const iframeVideo = homeVideoLightboxContainer.querySelector('iframe');
            console.log(iframeVideo);
            iframeVideo.src = iframeVideo.src.replace('autoplay=1', '');
        }
    });

    homeVideoLightboxFigure.addEventListener('click', function(e){
        e.stopPropagation();
    });
};